import { AB_PLATFORM_SSR, AB_PLATFORM_IGNORE } from '@src/config/constants'
import { getAssignedExperimentBuckets } from '@src/experiments'
import { AssignedExperimentBucket } from '@src/experiments/experiments.types'
import pageExperimentManager from '@src/experiments/pageExperiments'
import { statsigExperimentManager } from '@src/experiments/statsig-integration'
import AuthUtil from '@src/quince-site-common/src/utils/authUtil'
import { AB_PAGE_NEW_HOME_PAGE, ANALYTIC_COOKIES } from '@src/quince-site-common/src/utils/constants'
import getCookie from '@src/quince-site-common/src/utils/getCookie'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

const getIsPlatformSSR = (): string[] => {
  if (!isBrowser()) return []
  const platformCookie = getCookie(ANALYTIC_COOKIES.PLATFORM_AB)
  // eslint-disable-next-line i18next/no-literal-string
  if (platformCookie?.includes('ssr')) return [AB_PLATFORM_SSR]
  // eslint-disable-next-line i18next/no-literal-string
  if (platformCookie?.includes('ignore')) return [AB_PLATFORM_IGNORE]
  return []
}

const shouldTrackBucketForUser = (experiment: AssignedExperimentBucket): boolean => {
  const loggedInUser = experiment.loggedInUsersOnly && AuthUtil.isLoggedIn()
  const loggedInCondition = !experiment.loggedInUsersOnly || loggedInUser

  return loggedInCondition
}

const getAssignedExperimentBucketsForLogging = () => {
  const assignedExperimentBuckets = getAssignedExperimentBuckets()
  const experimentsToTrack = Object.values(assignedExperimentBuckets)
    .filter(shouldTrackBucketForUser)
    .filter(experiment => experiment.isActive)
  const assignedExpLogs = experimentsToTrack.map(experiment => ({
    experimentName: experiment.name,
    bucketName: experiment.bucket,
  }))

  return assignedExpLogs
}

const getPageExperiments = () => {
  if (!isBrowser()) return []

  const pageManagerExperiments = pageExperimentManager.getUserBucketsForEventLogging()

  const experimentMap = new Map(pageManagerExperiments.map(exp => [exp.experimentName, exp]))

  if (!experimentMap.has(AB_PAGE_NEW_HOME_PAGE)) {
    const pageABNewHomePageCookie = getCookie(ANALYTIC_COOKIES.PAGE_AB_NEW_HOME_PAGE)
    if (pageABNewHomePageCookie) {
      const pageABNewHomePageCookieValue = pageABNewHomePageCookie.split('_')?.[0] ?? ''
      experimentMap.set(AB_PAGE_NEW_HOME_PAGE, {
        experimentName: AB_PAGE_NEW_HOME_PAGE,
        bucketName: pageABNewHomePageCookieValue,
      })
    }
  }

  return Array.from(experimentMap.values())
}

export const getActiveExperiments = () => {
  const activeExperiments = []

  const experimentBuckets = [
    ...getAssignedExperimentBucketsForLogging(),
    ...getPageExperiments(),
    ...statsigExperimentManager.getActiveExposedBuckets(),
  ]
  for (const experimentBucket of experimentBuckets) {
    activeExperiments.push(`${experimentBucket.experimentName}_${experimentBucket.bucketName}`)
  }

  return [...activeExperiments, ...getIsPlatformSSR()]
}
